import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../../../api/auth/index';
import { authActions } from '../../Auth/_redux/authActions';

/** Cierra la sesión (borra cookies en el servidor y el estado local) y vuelve al login. */
function Logout() {
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				await logout();
			} catch (e) {
				/* aunque falle el servidor, cerramos localmente */
			}
			if (cancelled) return;
			dispatch(authActions.logoutAction());
			history.replace('/auth/login');
		})();
		return () => {
			cancelled = true;
		};
	}, [dispatch, history]);

	return <div className="p-10 text-muted">Cerrando sesión…</div>;
}

export default Logout;
